import { combineReducers } from "redux";
import ReduxGenerator from './redux-generator';
import deviceReducer from "./deviceReducer";
import rethinkReducer from './rethink-reducer';
import serverAppLogsReducer from './serverAppLogs-reducer';
import { ActionTypes } from '../constants';
import storeTypesPersist from './fb-source-types';
import notificationsTypesPersist from './fb-notification-types';
import checkSortReducer from './fb-sort-checks';
import deviceInfoReducer from './device-info';
import deviceApiDataReducer from './device-api-data';
import notificationReducer from './notification-reducer';
import currencyReducer from './currency-reducer';
import fbNetworkLogsReducer from './fbNetwork-logs-reducer';
import exceptionReducer from './exception-reducer';
import checksSyncReducer from './checks-sync-reducer';
import teamshareFilterPersist from './teamshare-filter-reducer';
import componentState from './component-state-reducer';
import printLogs from './print-log-reducer';
import fbCheckFilters from "./fb-check-filters";
import deviceApiReducer from './device-api';
import labelsReducer from '../slice/labelsSlice';
import themeReducer from '../slice/themeSlice';

const rootReducer = combineReducers({
  device: deviceReducer,
  serverAppLogin: ReduxGenerator.getReducer('SA_LOGIN', 'serverAppLogin'),
  login: ReduxGenerator.getReducer('LOGIN', 'login'),
  deviceApi: deviceApiReducer,//ReduxGenerator.getReducer(ActionTypes.DEVICE_ACTIVATION, 'deviceApi'),
  deviceInfo: deviceInfoReducer,
  deviceApiData: deviceApiDataReducer,
  storeInfo: ReduxGenerator.getReducer(ActionTypes.STORE_INFO, 'storeInfo'),

  activateDevice: ReduxGenerator.getReducer(
    ActionTypes.DEVICE_ACTIVATION_REQUEST,
    'activateDevice',
  ),
  acknowledgeNotification: ReduxGenerator.getReducer(
    ActionTypes.ACKNOWLEDGE_NOTIFICATION,
    'acknowledgeNotification',
  ),
  tableReceiptPrint: ReduxGenerator.getReducer(
    ActionTypes.TABLE_RECEIPT_PRINT,
    'tableReceiptPrint',
  ),
  reactivateDevice: ReduxGenerator.getReducer(ActionTypes.REACTIVATE_DEVICE, 'reactivateDevice'),
  rethink: rethinkReducer,
  storeTypesPersist,
  appLogs: serverAppLogsReducer,
  appExceptions: exceptionReducer,
  notifications: notificationReducer,
  notificationsTypesPersist,
  checkSortReducer,
  getStoreByIdReducer: ReduxGenerator.getReducer(
    ActionTypes.GET_STORE_BY_ID,
    'getStoreByIdReducer',
  ),
  currencyInfo: currencyReducer,
  fbNetworkLogs: fbNetworkLogsReducer,
  initializeCashPayment: ReduxGenerator.getReducer(
    ActionTypes.CASH_PAYMENT,
    'initializeCashPayment',
  ),
  initializePayment: ReduxGenerator.getReducer(ActionTypes.CARD_PAYMENT, 'initializePayment'),
  paymentIngenicoComplete: ReduxGenerator.getReducer(
    ActionTypes.PAYMENT_INGENICO_COMPLETE,
    'paymentIngenicoComplete',
  ),
  validateGiftCard: ReduxGenerator.getReducer(ActionTypes.VALIDATE_GIFTCARD, 'validateGiftCard'),
  paymentGiftCardInit: ReduxGenerator.getReducer(
    ActionTypes.PAYMENT_GIFT_CARD_INIT,
    'paymentGiftCardInit',
  ),
  paymentGiftCardComplete: ReduxGenerator.getReducer(
    ActionTypes.PAYMENT_GIFT_CARD_COMPLETE,
    'paymentGiftCardComplete',
  ),
  getStoreJobs: ReduxGenerator.getReducer(ActionTypes.GET_STORE_JOBS, 'getStoreJobs'),

  emailReceipt: ReduxGenerator.getReducer(ActionTypes.EMAIL_RECEIPT, 'emailReceipt'),
  smsReceipt: ReduxGenerator.getReducer(ActionTypes.SMS_RECEIPT, 'smsReceipt'),
  printReceipt: ReduxGenerator.getReducer(ActionTypes.PRINT_RECEIPT, 'printReceipt'),
  checksSyncState: checksSyncReducer,
  teamshareFilterPersist,
  componentState,
  retryPOSPayment: ReduxGenerator.getReducer(ActionTypes.RETRY_POS_PAYMENT, 'retryPOSPayment'),
  printLogs,
  fbCheckFilters,
  labelsData: labelsReducer,
  theme: themeReducer,
});

export default rootReducer;
